import { extendTheme } from '@chakra-ui/react';
import { baseTheme } from '@chakra-ui/theme';
import styles from './styles';
import { switchTheme } from './switch';

const { Button } = baseTheme.components;
const { Input } = baseTheme.components;
const { Checkbox } = baseTheme.components;
const { Link } = baseTheme.components;
const { Alert } = baseTheme.components;
const { Progress } = baseTheme.components;
const { Select } = baseTheme.components;
const { Textarea } = baseTheme.components;
const { UnorderedList } = baseTheme.components;
const { ListItem } = baseTheme.components;
const { ListIcon } = baseTheme.components;
const { List } = baseTheme.components;
const { Table } = baseTheme.components;
const { Thead } = baseTheme.components;
const { Tbody } = baseTheme.components;
const { Heading } = baseTheme.components;
const { TableContainer } = baseTheme.components;
const { Modal } = baseTheme.components;
const { ModalOverlay } = baseTheme.components;
const { ModalContent } = baseTheme.components;
const { ModalHeader } = baseTheme.components;
const { ModalFooter } = baseTheme.components;
const { ModalBody } = baseTheme.components;
const { ModalCloseButton } = baseTheme.components;
const { Radio } = baseTheme.components;
const { RadioGroup } = baseTheme.components;
const { Spinner } = baseTheme.components;
const { IconButton } = baseTheme.components;
const { Skeleton } = baseTheme.components;
const { Popover } = baseTheme.components;
const { PopoverTrigger } = baseTheme.components;
const { PopoverContent } = baseTheme.components;
const { PopoverHeader } = baseTheme.components;
const { PopoverBody } = baseTheme.components;
const { PopoverFooter } = baseTheme.components;
const { PopoverArrow } = baseTheme.components;
const { PopoverCloseButton } = baseTheme.components;
const { PopoverAnchor } = baseTheme.components;
const { Tooltip } = baseTheme.components;

export default extendTheme({
    components: {
        Popover,
        PopoverAnchor,
        PopoverArrow,
        PopoverBody,
        PopoverTrigger,
        PopoverContent,
        PopoverFooter,
        PopoverHeader,
        PopoverCloseButton,
        Button,
        Input,
        Checkbox,
        Link,
        Alert,
        Progress,
        Select,
        Textarea,
        UnorderedList,
        ListItem,
        ListIcon,
        List,
        Table,
        Thead,
        Tbody,
        IconButton,
        Heading,
        Skeleton,
        TableContainer,
        Modal,
        ModalOverlay,
        ModalContent,
        ModalHeader,
        ModalFooter,
        ModalBody,
        ModalCloseButton,
        Radio,
        RadioGroup,
        Spinner,
        Switch: switchTheme,
        Tooltip,
    },
    styles,
});
